module.exports = __webpack_public_path__ + "fonts/Sarabun-ThinItalic.242ea5dd.ttf";